import { inject, Injectable, signal } from '@angular/core';

import {
    SelectedEntitiesByLayerId,
    SelectedEntity,
    SelectionStateService,
} from '@connect-services/client/services/map/selection/selection-state.service';
import { LayersAndEntitiesSelection } from '@connect-services/client/services/statistic.service';
import { SelectOption } from '@connect-services/src/lib/components/select/select.component';

@Injectable({
    providedIn: 'root',
})
export class GeographicFilterService {
    public readonly isDrawControlActive = signal<boolean>(false);
    public readonly isGeographicFilterAllowedOnComponent = signal<boolean>(true);
    public readonly isSelectZoneActive = signal<boolean>(false);
    public readonly isSelectZoneControlActive = signal<boolean>(false);
    public readonly isStatisticFilterApplied = signal<boolean>(false);
    public readonly isVisible = signal<boolean>(true);
    public readonly selectedExtentLayersAndEntities = signal<LayersAndEntitiesSelection | undefined>(undefined);

    private readonly selectionStateService = inject(SelectionStateService);

    public resetGeographicFilterData(): void {
        this.isSelectZoneActive.set(false);
        this.isStatisticFilterApplied.set(false);
    }

    public updateLayerSelectionState(
        selectedOptions: SelectOption<string[]>[],
        availableOptions: SelectOption<string[]>[],
    ): string[] {
        const nextLayerIds: string[] = selectedOptions.flatMap((option: SelectOption<string[]>) => option.value);
        const manageableLayerIds: Set<string> = new Set(
            availableOptions.flatMap((option: SelectOption<string[]>) => option.value),
        );
        const previous: SelectedEntitiesByLayerId = this.selectionStateService.selectedEntitiesByLayerId();

        const removedLayerIds: string[] = Object.keys(previous).filter((layerId: string) => {
            return manageableLayerIds.has(layerId) && !nextLayerIds.includes(layerId);
        });

        const preservedEntries: SelectedEntitiesByLayerId = Object.fromEntries(
            Object.entries(previous).filter(
                ([layerId]: [string, SelectedEntity[]]) => !manageableLayerIds.has(layerId),
            ),
        );

        const nextSelectedEntitiesByLayerId: SelectedEntitiesByLayerId = nextLayerIds.reduce(
            (acc: SelectedEntitiesByLayerId, layerId: string) => {
                acc[layerId] = previous[layerId] ?? [];

                return acc;
            },
            preservedEntries,
        );

        this.selectionStateService.storeSelectedEntities(nextSelectedEntitiesByLayerId);

        return removedLayerIds;
    }
}
